module.exports = __webpack_public_path__ + "static/img/DigitalFinance.e8e506fd.jpg";